import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=1c39db5b&scoped=true&"
import script from "./BrandList.vue?vue&type=script&lang=js&"
export * from "./BrandList.vue?vue&type=script&lang=js&"
import style0 from "./BrandList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrandList.vue?vue&type=style&index=1&id=1c39db5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39db5b",
  null
  
)

export default component.exports